import { defineComponent as _defineComponent } from 'vue'
import useProfileState from '@/state/profile/profileState';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptySection',
  setup(__props) {

const { isSelf } = useProfileState();

return { __sfc: true,isSelf }
}

})